module.exports = __webpack_public_path__ + "fbac34ed3c7af6bc0ef2289c4f63380e.png";